import "./hippodrome.css";
import {useEffect} from "react";
import {getDateHumanize, ServerDate} from "../../services/misc.functions";
import {courseColors} from "../../constants/bulletin.constants";
import {useAvailableFOBHippodromes, useAvailableHippodromes, useDailyRaces} from "../../features/bulletin/bulletin.store";
import {homeHippodrome, homeHippodromeSubject, path} from "../../store/misc.store";
import {Hippodrome} from "../../models/bulletin.models";
import paths from "../../paths";
import {useLocation, useNavigate} from "react-router-dom";
import {MutualBetslip, useMutualSlipOptions} from "../../features/betslip/mutual.service";
import {isMobile} from "../../App";
import {ScrollArrows, useHorizontalScroller} from "./scroll-arrows";


/**
 * Kart bugüne ait DEĞİLSE "01.09" etiketi, bugüne aitse boş dize.
 * Eskiden `dateFormat(...).replace(`.${yıl}`, '')` kullanılıyordu; `dateFormat`
 * `toLocaleDateString()` çağırdığı için tarayıcı yerelinde en-US olan makinede
 * "9/1/2026" üretiyor, yıl kırpması `.2026` kalıbına bağlı olduğundan tutmuyordu.
 * Gün karşılaştırması da yalnız ayın gününe bakıyordu (ay/yıl dönümünde yanlış).
 */
function cardDayLabel(date: string): string {
    const cardDate = new Date(date);
    if (Number.isNaN(cardDate.getTime())) {
        return "";
    }
    const today = ServerDate();
    if (cardDate.getDate() === today.getDate()
        && cardDate.getMonth() === today.getMonth()
        && cardDate.getFullYear() === today.getFullYear()) {
        return "";
    }
    return `${String(cardDate.getDate()).padStart(2, "0")}.${String(cardDate.getMonth() + 1).padStart(2, "0")}`;
}

export function HippodromeWidget(props: any) {
    const slipOptions = useMutualSlipOptions();
    const dailyRaces = useDailyRaces();
    const availableHippodromes = useAvailableHippodromes();
    const availableFobHippodromes = useAvailableFOBHippodromes();
    const scroller = useHorizontalScroller();
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const hideKarma = props.hideKarma || false;
    const selectedHippodromeId = props.selectedHippodromeId ?? slipOptions?.hippodrome?._id;

    const hippodromes = pathname.includes(paths.bettingFob.url)
        ? availableFobHippodromes
        : pathname.includes(paths.betting.url)
            ? availableHippodromes
            : dailyRaces;

    const defaultHippodrome = () => {
        const withWagers = hippodromes.filter((el: any) => el.wager_details.length > 0);
        return withWagers.find((el: any) => el.nextRun) ?? withWagers[0];
    };

    useEffect(() => {
        const isBettingPage = pathname.includes(paths.betting.url) || pathname.includes(paths.bettingFob.url);
        const hasHippodromeInUrl = isBettingPage && pathname.split('/').filter(Boolean).length > 1;
        if (hasHippodromeInUrl) {
            return;
        }
        if (!homeHippodrome?._id && !MutualBetslip.getOptions().hippodrome) {
            const fallback = defaultHippodrome();
            if (fallback) {
                changeSelectedHippodrome(fallback);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hippodromes, pathname]);

    const changeSelectedHippodrome = (hippodrome: any) => {
        if (!hippodrome) {
            return;
        }
        try {
            // @ts-ignore
            dataLayer.push({
                event: "tab_view",
                button_name: hippodrome.location, // Ekranda olan koşular veya hipodrom ismi
                area_page: pathname === '/' ? "Anasayfa" : pathname // Tab'lerin hangi sayfada gösterildiği bilgisi
            });
        } catch (e) {

        }

        if (pathname === '/' || pathname.includes(paths.possibles.url) || pathname.includes(paths.dailyRaces.url) || pathname.includes(paths.notRunningHorses.url) || pathname.includes(paths.jockeyChanges.url) || pathname.includes(paths.tipsterComments.url)) {
            Object.assign(homeHippodrome, hippodrome);
            homeHippodromeSubject.next(hippodrome);
            MutualBetslip.setOptions({hippodrome});
        } else {
            MutualBetslip.setOptions({bettingType: null, bettingSubType: null, column: 1});
            if (pathname.includes(paths.betting.url)) {
                navigate(`${paths.betting.url}/${(hippodrome.keyword + hippodrome._id).toLowerCase()}`);
            } else if (pathname.includes(paths.bettingFob.url)) {
                navigate(`${paths.bettingFob.url}/${(hippodrome.keyword + hippodrome._id).toLowerCase()}`);
            }
        }
    }

    useEffect(() => {
        if (pathname === '/' && homeHippodrome?._id !== slipOptions?.hippodrome?._id) {
            changeSelectedHippodrome(defaultHippodrome());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, hippodromes, slipOptions?.hippodrome?._id]);

    if (isMobile) {
        return (
            <div className={"hippodrome-wrapper"}>
                <div className="hippodrome-container">
                    <div className={"container hippodrome-scroller"}>
                        <ScrollArrows scroller={scroller}/>
                        <div className="hippodrome-widgets" ref={scroller.ref}>
                            {hippodromes.map((hippodrome: Hippodrome, keyHippodrome: number) => {
                                if (hideKarma === true && hippodrome.keyword === 'KARMA') return;

                                if (pathname.includes(paths.betting.url)) {
                                    if (hippodrome.wager_details.length > 0) {
                                        return <div key={"hippodrome" + keyHippodrome} onClick={() => {
                                            changeSelectedHippodrome(hippodrome);
                                        }}
                                                    className={`hippodrome-item  ${selectedHippodromeId === hippodrome._id ? 'selected-hippodrome' : ''}`}>
                                            <div className={"d-flex justify-content-between align-items-center"}>
                                                <p className="text-start hippodrome-name text-truncate">{hippodrome.location}</p>
                                                <p className="text-xxsmall text-end">
                                                    {!hippodrome.status && hippodrome.nextRun != null && <span
                                                        className="float-start fw-bold">{getDateHumanize(hippodrome.date)} &nbsp;</span>}
                                                    {hippodrome.nextRun ? <> <span
                                                        className="text-xxsmall">{hippodrome.nextRun.no}.</span> Koşu: {hippodrome.nextRun.time} </> : <>
                                                        -
                                                    </>}
                                                </p>
                                            </div>
                                            <div className={"hippodrome-weather"}>
                                                <p className="text-xxsmall text-start text-truncate">
                                                    {hippodrome.weather && hippodrome.weather?.temperature} °C {hippodrome.weather?.forecast}</p>
                                            </div>


                                        </div>
                                    }
                                } else if (pathname.includes(paths.bettingFob.url)) {
                                    // Masaüstüyle aynı süzgeç: `nextRun` müşterek koşu durumundan geliyor,
                                    // sabit ihtimalli kartı ondan bağımsız açık olabilir.
                                    if (hippodrome.wager_details.length > 0 && hippodrome.show_fob) {
                                        return <div key={"hippodrome" + keyHippodrome} onClick={() => {
                                            changeSelectedHippodrome(hippodrome);
                                        }}
                                                    className={`hippodrome-item  ${selectedHippodromeId === hippodrome._id ? 'selected-hippodrome' : ''}`}>
                                            <p className="text-small text-bolder text-start hipodrome-item-text mb-1">
                                                {cardDayLabel(hippodrome.date) &&
                                                    <span
                                                        className="text-xxsmall">{cardDayLabel(hippodrome.date)} |</span>}
                                                {hippodrome.keyword}
                                            </p>
                                            <p className="text-xxsmall text-start mb-1">
                                                {hippodrome.nextRun ? <>
                                                <span
                                                    className="text-xxsmall">{hippodrome.nextRun.no}.</span> Koşu: {hippodrome.nextRun.time}
                                                </> : <>
                                                    Koşular Tamamlanmıştır
                                                </>}
                                            </p>
                                            <p className="text-xxsmall text-start text-truncate">
                                        <span
                                            className="text-xxsmall">Hava:</span> {hippodrome.weather && hippodrome.weather?.temperature} °C
                                                | {hippodrome.weather?.forecast}</p>
                                            {selectedHippodromeId === hippodrome._id &&
                                                <div className="selected-indicator"></div>
                                            }
                                        </div>
                                    }
                                } else {
                                    if (hippodrome.card_id != null) {
                                        return <div key={"hippodrome" + keyHippodrome} onClick={() => {
                                            changeSelectedHippodrome(hippodrome);
                                        }}
                                                    className={`hippodrome-item  ${selectedHippodromeId === hippodrome._id ? 'selected-hippodrome' : ''}`}>
                                            <div className={"d-flex justify-content-between align-items-center"}>
                                                <p className="text-start hippodrome-name text-truncate">{hippodrome.location}</p>
                                                <p className="text-xxsmall text-end">
                                                    {!hippodrome.status && hippodrome.nextRun != null && <span
                                                        className="float-start fw-bold">{getDateHumanize(hippodrome.date)} &nbsp;</span>}
                                                    {hippodrome.nextRun ? <> <span
                                                        className="text-xxsmall">{hippodrome.nextRun.no}.</span> Koşu: {hippodrome.nextRun.time} </> : <>
                                                        -
                                                    </>}
                                                </p>
                                            </div>
                                            <div className={"hippodrome-weather"}>
                                                <p className="text-xxsmall text-start text-truncate">
                                                    {hippodrome.weather && hippodrome.weather?.temperature} °C {hippodrome.weather?.forecast}</p>
                                            </div>


                                        </div>
                                    }
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={"hippodrome-wrapper"}>
            <div className="hippodrome-container">
                <div className={"container hippodrome-scroller"}>
                    <ScrollArrows scroller={scroller}/>
                    <div className="hippodrome-widgets" ref={scroller.ref}>
                        {hippodromes.map((hippodrome: Hippodrome, keyHippodrome: number) => {
                            if (hideKarma === true && hippodrome.keyword === 'KARMA') return;

                            if (pathname.includes(paths.betting.url)) {
                                if (hippodrome.wager_details.length > 0) {
                                    return <div key={"hippodrome" + keyHippodrome} onClick={() => {
                                        changeSelectedHippodrome(hippodrome);
                                    }}
                                                className={`hippodrome-item  ${selectedHippodromeId === hippodrome._id ? 'selected-hippodrome' : ''}`}>
                                        <p className="text-small text-bolder text-start hipodrome-item-text mb-1">
                                            {cardDayLabel(hippodrome.date) &&
                                                <span
                                                    className="text-xxsmall">{cardDayLabel(hippodrome.date)} |</span>}
                                            {hippodrome.keyword}
                                        </p>
                                        <p className="text-xxsmall text-start mb-1">
                                            {hippodrome.nextRun ? <>
                                                <span
                                                    className="text-xxsmall">{hippodrome.nextRun.no}.</span> Koşu: {hippodrome.nextRun.time}
                                            </> : <>
                                                Koşular Tamamlanmıştır
                                            </>}
                                        </p>
                                        <p className="text-xxsmall text-start text-truncate">
                                        <span
                                            className="text-xxsmall">Hava:</span> {hippodrome.weather && hippodrome.weather?.temperature} °C
                                            | {hippodrome.weather?.forecast}</p>
                                        {selectedHippodromeId === hippodrome._id &&
                                            <div className="selected-indicator"></div>
                                        }
                                    </div>
                                }
                            } else if (pathname.includes(paths.bettingFob.url)) {
                                // Liste zaten `availableFobHippodromes`; kaynak süzgeci burada TEKRARLANMIYOR.
                                // Eski hâli `getDateHumanize(date) === 'Bugün'` ve `nextRun` istiyordu: gece
                                // yarısını aşan yabancı kart (ör. Indianapolis, 21:10-00:47) dünün tarihiyle
                                // geldiği için tek açık kart bile listeden düşüyor, şerit bomboş kalıyordu.
                                // `nextRun` müşterek koşu durumundan (`status === 0`) türüyor - sabit
                                // ihtimalli bundan bağımsız açık olabilir, o yüzden o da süzgeç değil.
                                if (hippodrome.wager_details.length > 0 && hippodrome.show_fob) {
                                    return <div key={"hippodrome" + keyHippodrome} onClick={() => {
                                        changeSelectedHippodrome(hippodrome);
                                    }}
                                                className={`hippodrome-item  ${selectedHippodromeId === hippodrome._id ? 'selected-hippodrome' : ''}`}>
                                        <p className="text-small text-bolder text-start hipodrome-item-text mb-1">
                                            {cardDayLabel(hippodrome.date) &&
                                                <span
                                                    className="text-xxsmall">{cardDayLabel(hippodrome.date)} |</span>}
                                            {hippodrome.keyword}
                                        </p>
                                        <p className="text-xxsmall text-start mb-1">
                                            {hippodrome.nextRun ? <>
                                                <span
                                                    className="text-xxsmall">{hippodrome.nextRun.no}.</span> Koşu: {hippodrome.nextRun.time}
                                            </> : <>
                                                Koşular Tamamlanmıştır
                                            </>}
                                        </p>
                                        <p className="text-xxsmall text-start text-truncate">
                                        <span
                                            className="text-xxsmall">Hava:</span> {hippodrome.weather && hippodrome.weather?.temperature} °C
                                            | {hippodrome.weather?.forecast}</p>
                                        {selectedHippodromeId === hippodrome._id &&
                                            <div className="selected-indicator"></div>
                                        }
                                    </div>
                                }
                            }
                            else {
                                if (hippodrome.card_id != null) {
                                    return <div key={"hippodrome" + keyHippodrome} onClick={() => {
                                        changeSelectedHippodrome(hippodrome);

                                    }}
                                                className={`hippodrome-item  ${selectedHippodromeId === hippodrome._id ? 'selected-hippodrome' : ''}`}>
                                        <p className="text-small text-bolder text-start mb-1">{hippodrome.keyword}</p>
                                        <p className="text-xxsmall text-start mb-1">
                                            {!hippodrome.status && getDateHumanize(hippodrome.date) != 'Bugün' && <span
                                                className="float-start fw-bold">{getDateHumanize(hippodrome.date)} &nbsp;</span>}
                                            {hippodrome.nextRun ? <> <span
                                                className="text-xxsmall">{hippodrome.nextRun.no}.</span> Koşu: {hippodrome.nextRun.time} </> : <>
                                                Koşular Tamamlanmıştır
                                            </>}
                                        </p>
                                        <p className="text-xxsmall text-start text-truncate">
                                            <span
                                                className="text-xxsmall">Hava:</span> {hippodrome.weather && hippodrome.weather?.temperature} °C
                                            | {hippodrome.weather?.forecast}</p>
                                        {selectedHippodromeId === hippodrome._id &&
                                            <div className="selected-indicator"></div>
                                        }
                                    </div>
                                }
                            }
                        })}
                    </div>
                </div>

            </div>
            {(path.root === '/' || path.root.includes('at-yarisi-muhtemeller')) &&
                <div className={"bg-white"}>
                    <div className={"container"}>
                        <div className={"hippodrome-info-container"}>
                            <div className={"hippodrome-info"}>
                                <div className={"hippodrome-info-item"}>
                                    {homeHippodrome.location}
                                </div>
                                <div className={"hippodrome-info-item text-truncate"}>
                                    Hava: {homeHippodrome.weather?.temperature} °C | {homeHippodrome.weather?.forecast}
                                </div>
                                <div className={"hippodrome-info-item"}>
                                    <div className="me-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                             viewBox="0 0 10 10"
                                             fill="none">
                                            <path
                                                d="M2.08334 0.416748C1.93908 0.416748 1.80509 0.491366 1.72912 0.614002C1.71007 0.645054 1.69114 0.676183 1.67239 0.707419C1.63711 0.766181 1.58703 0.85064 1.52707 0.954627C1.40735 1.16224 1.24725 1.44943 1.08665 1.76643C0.926642 2.08227 0.762808 2.43421 0.638048 2.77016C0.517304 3.09531 0.416672 3.4478 0.416672 3.75008C0.416672 4.67056 1.16286 5.41675 2.08334 5.41675C3.00381 5.41675 3.75001 4.67056 3.75001 3.75008C3.75001 3.4478 3.64937 3.09531 3.52863 2.77016C3.40387 2.43421 3.24004 2.08227 3.08003 1.76643C2.91943 1.44943 2.75933 1.16224 2.63961 0.954627C2.57964 0.85064 2.52956 0.766181 2.49429 0.707419C2.47553 0.676183 2.45661 0.645054 2.43756 0.614002C2.36159 0.491366 2.2276 0.416748 2.08334 0.416748Z"
                                                fill="white"></path>
                                            <path
                                                d="M3.75001 6.66675C3.75001 8.27758 5.05584 9.58342 6.66667 9.58342C8.2775 9.58342 9.58334 8.27758 9.58334 6.66675C9.58334 6.13979 9.40458 5.49267 9.16665 4.85197C8.9247 4.20045 8.60462 3.51201 8.28836 2.88776C7.97151 2.26234 7.65516 1.69482 7.41825 1.28398C7.2997 1.07838 7.20079 0.911581 7.13133 0.795884C7.0966 0.738026 7.06921 0.692919 7.0504 0.6621L7.02089 0.614002C6.94492 0.491366 6.81093 0.416748 6.66667 0.416748C6.52241 0.416748 6.38842 0.491366 6.31246 0.614002L6.28294 0.6621C6.26413 0.692919 6.23675 0.738026 6.20201 0.795884C6.13256 0.911581 6.03365 1.07838 5.91509 1.28398C5.67818 1.69482 5.36183 2.26234 5.04498 2.88776C4.72873 3.51201 4.40864 4.20045 4.16669 4.85197C3.92876 5.49267 3.75001 6.13979 3.75001 6.66675Z"
                                                fill="white"></path>
                                        </svg>
                                    </div>
                                    Nem: {homeHippodrome.weather?.humidity}
                                </div>
                                {homeHippodrome.nextRun && <div className={"hippodrome-info-item"}
                                                                style={{backgroundColor: courseColors[homeHippodrome.nextRun.course]}}>
                                    {homeHippodrome.nextRun.course} {homeHippodrome.weather.course_condition ? ":" : ""} {homeHippodrome.weather.course_condition}
                                </div>}

                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}


